import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import { useLocation } from "react-router-dom";
import IncomeReportChild from "./IncomeReportChild";

const IncomeReport = () => {
  const { state } = useLocation();
  const incomeData = state;
  return (
    <MainTemplate>
      <CardBackground>
        <IncomeReportChild incomeData={incomeData} />
      </CardBackground>
    </MainTemplate>
  );
};

export default IncomeReport;
